import React from 'react';
import PropTypes from 'prop-types';
import { Tag as AntTag } from 'antd';
import { GREEN, ORANGE, RED } from '../chart/colors';
import { startCase } from 'lodash';

const AssetsStatusTag = (props) => (
  <AntTag
    color={
      {
        IN_PROGRESS: ORANGE,
        DONE: GREEN,
        TO_DO: RED,
      }[props.status]
    }
  >
    {startCase(props.status.toLowerCase().replace('_', ' '))}
  </AntTag>
);

AssetsStatusTag.propTypes = {
  status: PropTypes.oneOf(['TO_DO', 'IN_PROGRESS', 'DONE']).isRequired,
};

export default AssetsStatusTag;
